import { createSlice } from "@reduxjs/toolkit";

export const initialBookingState = {
  clientId: null,
  clientSecret: null,
  customerStrategy: null,
};

export const intialFinancialState = {
  payment_terms: 'Payment due on presentation of invoice',
  deposit_payment_percent: null,
  invoice_due_days: null,
  accounting_package: null,
  vat_percent: null,
  vat_reg_no: null,
  cancellation_fees: [],
  invoice_types: [],
  payment_methods: [],
};

export const quickBookSlice = createSlice({
  name: "quickBook",
  initialState: {
    bookings: [],
    singleBooking: {},
    newFinancialState: intialFinancialState,
    isBookingAdded: false,
    isBookingUpdated: false,
    isBookingDeleted: false,
    isPostFinancial: false,
    invoiceTypes: [],
    paymentMethods: [],
  },
  reducers: {
    getAllBookings: (state) => {},
    setAllBookings: (state, { payload }) => {
      state.bookings = payload?.list;
    },
    getQuickBookDetails: (state) => {},
    setQuickBookDetails: (state, { payload }) => {
      state.singleBooking = payload?.quickBook;
    },
    addBooking: (state, { payload }) => {},
    setAddBookingResponse: (state, { payload }) => {
      state.isBookingAdded = payload;
    },

    updateBooking: (state, { payload }) => {},
    setUpdateBookingResponse: (state, { payload }) => {
      state.isBookingUpdated = payload;
    },
    deleteBooking: (state, { payload }) => {},
    setDeleteBookingResponse: (state, { payload }) => {
      state.isBookingDeleted = payload;
    },

    getFinancialAction: (state) => {},
    setFinancialDetails: (state, { payload }) => {
      state.newFinancialState = payload;
    },

    postFinancialAction: (state, { payload }) => {},
    setPostFinancialResponse: (state, { payload }) => {
      state.isPostFinancial = payload;
    },

    getInvoiceTypeListAction: (state) => {},
    setInvoiceTypeListAction: (state, { payload }) => {
      state.invoiceTypes = payload;
    },

    getPaymentMethodListAction: (state) => {},
    setPaymentMethodListAction: (state, { payload }) => {
      state.paymentMethods = payload;
    },
  },
});
const {
  getAllBookings,
  setAllBookings,
  addBooking,
  setAddBookingResponse,
  updateBooking,
  setUpdateBookingResponse,
  deleteBooking,
  setDeleteBookingResponse,
  getQuickBookDetails,
  setQuickBookDetails,
  getFinancialAction,
  setFinancialDetails,
  postFinancialAction,
  setPostFinancialResponse,
  getInvoiceTypeListAction,
  setInvoiceTypeListAction,
  getPaymentMethodListAction,
  setPaymentMethodListAction,
} = quickBookSlice.actions;
export {
  getAllBookings,
  setAllBookings,
  addBooking,
  setAddBookingResponse,
  updateBooking,
  setUpdateBookingResponse,
  deleteBooking,
  setDeleteBookingResponse,
  getQuickBookDetails,
  setQuickBookDetails,
  getFinancialAction,
  setFinancialDetails,
  postFinancialAction,
  setPostFinancialResponse,
  getInvoiceTypeListAction,
  setInvoiceTypeListAction,
  getPaymentMethodListAction,
  setPaymentMethodListAction,
};
export default quickBookSlice.reducer;
